import Cookies from 'js-cookie'

export function setStateIsNight (value) {
  Cookies.set('nightmode_is_night', value)
}

export function getStateIsNight () {
  return Cookies.get('nightmode_is_night') === 'true'
}
